import React from "react";

export default function DashboardAdmin() {
  return (
    <>
      <div>Trang chủ Dashboard</div>
    </>
  );
};
